import {Optional} from '@othree.io/optional'
import {Attribute, ITable, Table, TableProps} from 'aws-cdk-lib/aws-dynamodb'
import {Stack} from 'aws-cdk-lib'

export type TableInput = Readonly<{
    id: string
    partitionKey: Attribute
    sortKey?: Attribute
}>

/** Creates a DynamoDB table with default and optional per-call configuration overrides. */
export const withTable = (deps: {
    defaultConfiguration: Partial<TableProps>
    stack: Stack
}) =>
    (input: TableInput, configuration?: Partial<TableProps>): ITable => {
        const table = new Table(deps.stack, input.id, {
            ...deps.defaultConfiguration,
            tableName: input.id,
            partitionKey: input.partitionKey,
            sortKey: input.sortKey,
            ...Optional(configuration).orElse({}),
        })

        return table
    }
